
import React from 'react';
import { useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Link } from 'office-ui-fabric-react/lib/Link';

import Text from '../../../common/client/components/Text';

import { getDrupozTitle } from '../../../reducers/drupoz';
import { getParName } from '../../../reducers/par';

import ToolLinks from '../ToolLinks';
import IfComp from '../IfComp';
import LinkToParcela from './LinkToParcela';
import ListInfoLoading from './ListInfoLoading';
import ListInfoNoData from './ListInfoNoData';

const classNames = mergeStyleSets({
    row: {
        paddingLeft: 0,
    },
    rowCompact: {
        paddingLeft: 0,
    },
    parClick: {
        '&:hover': {
            backgroundColor: '#dddddd',
            cursor: 'pointer'
        }
    },
    parTitle: {
        paddingLeft: 0,
        paddingBottom: 4
    },
    parKatuze: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: 200
    },
    parName: {
        width: 100
    },
    parType: {
        width: 40
    },
    parDrupoz: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: 32,
        width: 200
    },
    parVymera: {
        width: 100,
        textAlign: 'right'
    },
    parContainer: {
        paddingTop: 4,
        paddingBottom: 4,
        paddingLeft: 0
    },
    parContainerCompact: {
        paddingTop: 4,
        paddingBottom: 4,
        paddingLeft: 0
    }
});

const IsknParTitle = () => {
    return (
        <Stack horizontal verticalAlign="end" className={classNames.parTitle}>
            <Text bold className={classNames.parKatuze}>Katastrální území</Text>
            <Text bold className={classNames.parName}>Parcelní číslo</Text>
            <Text bold className={classNames.parType}>Typ</Text>
            <Text bold className={classNames.parVymera}>Výměra</Text>
            <Text bold className={classNames.parDrupoz}>Druh pozemku</Text>
        </Stack>
    );
}

const IsknParItem = ({
    compact,
    isknDate,
    parItem,
    tools,
    onClick,
    onShowInMap
}) => {

    const drupozTitle = useSelector(state => getDrupozTitle(state.drupoz, parItem.drupoz_kod));

    const handleClick = () => {
        if (onClick) {
            onClick(parItem.par_id);
        }
    }

    const handleClickMap = () => {
        if (onShowInMap) {
            onShowInMap(parItem);
        }
    }

    let classNamesArr = [compact ? classNames.rowCompact : classNames.row];
    if (onClick) {
        classNamesArr.push(classNames.parClick)
    }

    return (
        <Stack horizontal verticalAlign="end" className={classNamesArr.join(' ')} onClick={handleClick}>
            <IfComp cond={!compact}>
                <Text className={classNames.parKatuze}>{parItem.katuze_name}</Text>
                <Text bold className={classNames.parName}>{getParName(parItem)}</Text>
            </IfComp>
            <IfComp cond={compact}>
                <Stack.Item className={classNames.parName}>
                    <LinkToParcela isknDate={isknDate} par={parItem} />
                </Stack.Item>
            </IfComp>
            <Text className={classNames.parType}>{parItem.par_type}</Text>
            <Text className={classNames.parVymera}>{parItem.vymera_parcely} m<sup>2</sup></Text>
            <Text className={classNames.parDrupoz}>{drupozTitle}</Text>
            <IfComp cond={!!onShowInMap && !!parItem.souradnice_x && !!parItem.souradnice_y}>
                <Link onClick={handleClickMap} >Do mapy</Link>
            </IfComp>
            <ToolLinks
                tools={tools || []}
                par={parItem}
            />
        </Stack>
    );
}

const IsknParList = ({
    compact,
    isknDate,
    data,
    loading,
    tools,
    onClick,
    onShowInMap
}) => {

    return (
        <Stack className={compact ? classNames.parContainerCompact : classNames.parContainer}>
            <IfComp cond={!compact && (data.par.length > 0)}>
                <IsknParTitle />
            </IfComp>
            {data.par.map(item => {
                return (
                    <IsknParItem
                        key={item.par_id}
                        compact={compact}
                        isknDate={isknDate}
                        parItem={item}
                        tools={tools}
                        onClick={onClick}
                        onShowInMap={onShowInMap}
                    />
                );
            })}
            <IfComp cond={loading}>
                <ListInfoLoading />
            </IfComp>
            <IfComp cond={(data.par.length === 0) && !loading}>
                <ListInfoNoData />
            </IfComp>
        </Stack>
    );
}

export default IsknParList;
